<template>
  <b-modal
    v-model="editorShown"
    centered
    title="Send Patient Portal Link"
    header-bg-variant="primary"
    header-text-variant="white"
    no-close-on-backdrop
  >
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="editorShown = false">
        Cancel
      </b-button>
      <b-button
        variant="primary"
        :disabled="!sendByEmail && !sendBySms"
        @click="sendLink()"
      >
        Send
      </b-button>
    </template>
    <b-form-group label="Patient portal account"> </b-form-group>
    <b-form-group
      :state="formErrors.value.length == 0 ? null : false"
      :invalid-feedback="formErrors.value.join(', ')"
    >
      <v-select
        v-model="portalAccess"
        :options="portalAccesses"
        return-object
        :clearable="false"
      />
    </b-form-group>
    <b-form-group
      :state="formErrors.email.length == 0 ? null : false"
      :invalid-feedback="formErrors.email.join(', ')"
    >
      <b-row class="my-1" align-v="center">
        <b-col sm="4">
          <b-form-checkbox
            v-model="sendByEmail"
            :value="true"
            :unchecked-value="false"
          >
            Send email to
          </b-form-checkbox>
        </b-col>

        <b-col sm="8">
          <b-form-input
            v-model="email"
            :state="formErrors.email.length == 0 ? null : false"
            maxLength="100"
          ></b-form-input>
        </b-col>
      </b-row>
    </b-form-group>
    <!-- this imput will be requerid in the future -->
    <b-form-group
      :state="formErrors.phone.length == 0 ? null : false"
      :invalid-feedback="formErrors.phone.join(', ')"
    >
      <b-row class="my-1" align-v="center">
        <b-col sm="4">
          <b-form-checkbox
            v-model="sendBySms"
            :value="true"
            :unchecked-value="false"
          >
            Send sms to
          </b-form-checkbox>
        </b-col>
        <b-col sm="8">
          <phone-input
            ref="phoneInput"
            defaultCountry="US"
            v-model="phone"
            trim
            :state="formErrors.phone.length == 0 ? null : false"
          ></phone-input>
        </b-col>
      </b-row>
    </b-form-group>
  </b-modal>
</template>

<script>
import notificationServer from "../../server/notification";
import portalAccessServer from "../../server/portalAccess";
import { mapActions } from "vuex";
import {
  validatePhoneNumber,
  validateEmail,
  validateRequired
} from "../../helpers/validation";
import PhoneInput from "../controls/PhoneInput.vue";

export default {
  name: "SendPatientPortalLinkModal",
  components: { PhoneInput },
  data() {
    return {
      portalAccesses: [],
      value: null,
      label: null,
      email: null,
      phone: null,
      sendByEmail: true,
      sendBySms: true,
      formErrors: {
        email: [],
        phone: [],
        value: []
      }
    };
  },
  props: ["patientId"],
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    async fetchClients() {
      this.portalAccesses = (
        await portalAccessServer.findAllAccess(this.patientId)
      ).map(contact => ({
        value: contact.id,
        label: `${contact.name} (${contact.relationship})`,
        email: contact.email,
        phone: contact.phone
      }));
    },
    sendLink() {
      this.validateSendPatientPortalLinkSubmit().then(withoutErrors => {
        if (withoutErrors) {
          notificationServer
            .sendPatientPortalLink(
              this.value,
              this.email,
              this.phone,
              this.sendByEmail,
              this.sendBySms
            )
            .then(() => {
              this.editorShown = false;
              this.showAlertSuccess();
            })
            .catch(function() {});
        }
      });
    },
    async validateSendPatientPortalLinkSubmit() {
      let withoutErrors = true;
      this.formErrors.email = [];
      this.formErrors.phone = [];
      this.formErrors.value = [];

      if (this.value == null) {
        this.formErrors.value.push("This field is required");
        withoutErrors = false;
      }
      if (this.email && !validateEmail(this.email)) {
        this.formErrors.email.push("This field must have a valid email format");
        withoutErrors = false;
      }
      if (this.sendByEmail && !validateRequired(this.email)) {
        this.formErrors.email.push("This field is required");
        withoutErrors = false;
      }

      if (
        this.phone &&
        this.phone.trim().length > this.activeCountry.dialCode.length + 1 &&
        !validatePhoneNumber(this.phone)
      ) {
        this.formErrors.phone.push("Invalid phone number");
        withoutErrors = false;
      }

      if (
        this.sendBySms &&
        (!validateRequired(this.phone) ||
          this.phone.trim().length <= this.activeCountry.dialCode.length + 1)
      ) {
        this.formErrors.phone.push("This field is required");
        withoutErrors = false;
      }
      return withoutErrors;
    }
  },
  computed: {
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    activeCountry() {
      return this.$refs.phoneInput.$refs.telInput.activeCountry;
    },
    portalAccess: {
      get() {
        return {
          value: this.value,
          email: this.email,
          phone: this.phone,
          label: this.label
        };
      },
      set(newVal) {
        this.value = newVal.value;
        this.email = newVal.email;
        this.phone = newVal.phone;
        this.label = newVal.label;
      }
    }
  },
  mounted() {
    this.fetchClients();
  }
};
</script>
